import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { ArrowRight, Sparkles } from 'lucide-react';
import styles from './ProductSuite.module.css';

const cardColors = ['#10b981', '#3b82f6', '#f59e0b']; // Green, Blue, Amber

export const ProductSuite: React.FC = () => {
  const { t } = useLanguage();
  const images = [
    {
      src: '/images/strategic_roadmap.png',
      webp: '/images/strategic_roadmap-800.webp 800w, /images/strategic_roadmap-1600.webp 1600w',
    },
    {
      src: '/images/security_governance_hero.png',
      webp: '/images/security_governance_hero-800.webp 800w, /images/security_governance_hero-1600.webp 1600w',
    },
    {
      src: '/images/erp_sap_hero.png',
      webp: '/images/erp_sap_hero-800.webp 800w, /images/erp_sap_hero-1600.webp 1600w',
    },
  ];

  return (
    <section className={styles.productSuite} id="products">
      <div className={styles.productSuite__container}>
        <div className={styles.productSuite__header}>
          <span className={styles.productSuite__tag}><Sparkles size={14} />{t.productSuite.tag}</span>
          <h2 className={styles.productSuite__title}>{t.productSuite.title}</h2>
          <p className={styles.productSuite__subtitle}>{t.productSuite.subtitle}</p>
        </div>

        <div className={styles.productSuite__grid}>
          {t.productSuite.items.map((item, index) => (
            <Link
              key={item.title}
              to={item.href}
              className={styles.productCard}
              style={{ '--accent-color': cardColors[index] } as React.CSSProperties}
            >
              <div className={styles.productCard__imageWrapper}>
                <picture>
                  <source
                    type="image/webp"
                    srcSet={(images[index] ?? images[0]).webp}
                    sizes="(max-width: 768px) 100vw, 360px"
                  />
                  <img
                    src={(images[index] ?? images[0]).src}
                    alt={item.title}
                    className={styles.productCard__image}
                    loading="lazy"
                  />
                </picture>
              </div>
              <span className={styles.productCard__eyebrow}>{item.eyebrow}</span>
              <h3 className={styles.productCard__title}>{item.title}</h3>
              <p className={styles.productCard__subtitle}>{item.subtitle}</p>
              <ul className={styles.productCard__list}>
                {item.bullets.map((bullet) => (
                  <li key={bullet} className={styles.productCard__listItem}>
                    <span className={styles.productCard__dot} />
                    {bullet}
                  </li>
                ))}
              </ul>
              <div className={styles.productCard__ctaRow}>
                <span className={styles.productCard__ctaText}>{item.cta}</span>
                <ArrowRight size={18} className={styles.productCard__arrow} />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductSuite;
